import { jsx as _jsx } from "react/jsx-runtime";
import { SvgCross } from '../../index';
import { TertiaryBtn } from '../btn/TertiaryBtn';
import './CloseDialogBtn.scss';
export function CloseDialogBtn({ tooltip, onClick, testId }) {
    return (_jsx("div", { className: 'sg-closeDialogBtn', children: _jsx("div", { className: 'sg-closeDialogBtn--inner', children: _jsx(TertiaryBtn, { isDanger: true, icon: { element: _jsx(SvgCross, {}) }, tooltip: tooltip, onClick: onClick, testId: testId }) }) }));
}
//# sourceMappingURL=CloseDialogBtn.js.map